module.exports = __webpack_public_path__ + "img/setting-icon.acfb7338.svg";